import normalizeThreadListScope from '@/lib/threads/normalizeThreadListScope.js';

/* A scoped hydration REPLACES every thread its scope owns (see matchesThreadListScope): a type the
   scope owns but the fetch never asks for is deleted from the store on the next hydration of that
   scope — thread row and transcript together. The fetch filter is therefore derived from the scope
   here instead of being passed in per call site. The workflows scope owns workflow_requirements and
   three call sites asked only for 'workflow', so a workflow still in its planning phase vanished
   mid-build along with its chat history. */
const THREAD_TYPE_IN_BY_SCOPE = Object.freeze({
  schedules: Object.freeze(['schedule']),
  triggers: Object.freeze(['trigger', 'trigger_run']),
  workflows: Object.freeze(['workflow', 'workflow_requirements'])
});

const buildThreadListHydrationRequest = ({ threadListScope = undefined } = {}) => {
  const nextRequest = {
    skipEvents: true
  };

  const normalizedThreadListScope = normalizeThreadListScope(threadListScope, '');

  if (!normalizedThreadListScope) {
    return nextRequest;
  }

  nextRequest.threadListScope = normalizedThreadListScope;

  const threadTypeIn = THREAD_TYPE_IN_BY_SCOPE[normalizedThreadListScope];

  if (threadTypeIn) {
    nextRequest.threadTypeIn = [...threadTypeIn];
    nextRequest.threadTypeNotIn = [];
  }

  return nextRequest;
};

export { THREAD_TYPE_IN_BY_SCOPE };
export default buildThreadListHydrationRequest;
